import React from "react";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import copilotStore from "Stores/copilotStore";
import ChatList from "./ChatList";

/** Under the empty home composer while it has focus: pick up a recent chat instead of starting one. */
const RecentChatsPopover = observer(() => {
  const history = useHistory();
  const items = (copilotStore.conversations || []).slice(0, 4);
  if (!items.length) return null;
  return (
    <div className="cpRecentPop">
      <div className="cpRecentPop__head">Continue a chat</div>
      <ChatList items={items} onOpen={c => history.push(`/copilot/${c.id}`)} />
      <div className="cpRecentPop__foot">Start typing for a new chat</div>
    </div>
  );
});

export default RecentChatsPopover;
